import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { formValueSelector, isPristine } from 'redux-form';

import { Inquiry } from 'verify/models/inquiry';

export const useShouldShowServerError = (
  inquiry: Inquiry,
  inquiryLoading: boolean,
  formField: string,
  prefill: string | undefined,
) => {
  const formName = inquiry.attributes['next-step'].name;

  const pristine = useSelector((state) => isPristine(formName)(state, formField));
  const value = useSelector((state) => formValueSelector(formName)(state, formField));

  const [shouldShowServerError, setShouldShowServerError] = useState(true);
  useEffect(() => {
    // hide server error after the first change form prefilled value
    // form is initialized with input.value = "" and pristine true
    // so this will not trigger when the value gets prefilled
    if ((prefill || '') !== (value || '') && !pristine) {
      setShouldShowServerError(false);
    }
  }, [pristine, prefill, value]);

  useEffect(() => {
    // if inquiry is updated, show server error again,
    // so that if the same server error occurs on transition
    // to same step, it's visible
    setShouldShowServerError(true);
  }, [inquiry]);

  useEffect(() => {
    if (inquiryLoading) {
      // as soon as we attempt to transition the inquiry, invalidate
      // the current server error in the component config
      setShouldShowServerError(false);
    }
  }, [inquiryLoading]);

  return shouldShowServerError;
};
